import { useState } from "react";
import { useReveal } from "../hooks/useReveal";
import "./Insights.css";

export default function Insights({ data }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const r1 = useReveal(), r2 = useReveal(), r3 = useReveal();

  const subscribe = async () => {
    if (!email) return;
    try {
      const r = await fetch("/api/newsletter", {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({ email }),
      });
      const j = await r.json();
      setStatus(j.success ? "ok" : "err");
      if (j.success) setEmail("");
    } catch { setStatus("err"); }
  };

  return (
    <div className="ins">

      {/* HERO */}
      <section className="ins-hero">
        <div className="ins-hero-inner wrap">
          <div>
            <span className="ins-hero-tag">{data?.hero?.tag}</span>
            <h1 className="ins-hero-h1">
              {data?.hero?.h1?.map((line,i)=>(
                <span key={i} className={line===data?.hero?.italic?"italic":""}>{line}<br/></span>
              ))}
            </h1>
          </div>
          <div>
            <p className="ins-hero-p">{data?.hero?.body}</p>
          </div>
        </div>
      </section>

      {/* FEATURED ARTICLE */}
      <section className="ins-featured" ref={r1}>
        <div className="ins-featured-inner wrap">
          <div className="ins-feat-meta rv">
            <span className="ins-feat-tag">{data?.featured?.tag}</span>
            <div className="ins-feat-badges">
              <span>{data?.featured?.date}</span>
              <span>{data?.featured?.readTime}</span>
            </div>
          </div>
          <div className="ins-feat-content">
            <h2 className="ins-feat-title rv">{data?.featured?.title}</h2>
            <p className="ins-feat-intro rv">{data?.featured?.intro}</p>

            {/* Key Points */}
            <div className="ins-key-points rv">
              <span className="ins-kp-label">Key Takeaways</span>
              {data?.featured?.keyPoints?.map((kp,i)=>(
                <div className="ins-kp-item" key={i}>
                  <span className="ins-kp-num">0{i+1}</span>
                  <p>{kp}</p>
                </div>
              ))}
            </div>

            {/* Full article (expandable) */}
            <div className={`ins-body${expanded?" expanded":""}`}>
              {data?.featured?.body?.map((p,i)=><p key={i}>{p}</p>)}
            </div>
            {!expanded && (
              <button className="ins-read-more rv" onClick={()=>setExpanded(true)}>
                Read Full Analysis →
              </button>
            )}
          </div>
        </div>
      </section>

      {/* MARKET BYTES */}
      <section className="ins-bytes" ref={r2}>
        <div className="ins-bytes-inner wrap">
          <div className="ins-bytes-hd">
            <span className="ins-bytes-tag rv">{data?.marketBytes?.tag}</span>
            <h2 className="ins-bytes-h2 rv">{data?.marketBytes?.h2}</h2>
            <span className="ins-bytes-period rv">{data?.marketBytes?.period}</span>
          </div>
          <div className="ins-bytes-grid">
            {data?.marketBytes?.items?.map((item,i)=>(
              <div className="ins-byte-card rv" key={i}>
                <span className="ins-byte-tag">{item.tag}</span>
                <h3 className="ins-byte-title">{item.title}</h3>
                <p className="ins-byte-body">{item.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SUBSCRIBE CTA */}
      <section className="ins-subscribe" ref={r3}>
        <div className="ins-sub-inner">
          <h2 className="ins-sub-h2 rv">{data?.cta?.h2}</h2>
          <p className="ins-sub-p rv">{data?.cta?.body}</p>
          <div className="ins-sub-form rv">
            <input type="email" placeholder="your@email.com" value={email}
              onChange={e=>setEmail(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&subscribe()}/>
            <button className="btn btn-r" onClick={subscribe}>{data?.cta?.cta}</button>
          </div>
          {status==="ok"  && <p className="ins-sub-msg">✓ You're on the list. Intelligence incoming.</p>}
          {status==="err" && <p className="ins-sub-msg err">Something went wrong. Try again.</p>}
        </div>
      </section>

    </div>
  );
}
